import { Button } from "components/DesignSystem/Button/Button";
import { DateInput } from "components/DesignSystem/DateInput/DateInput";
import Modal from "components/DesignSystem/Modal/Modal";
import { FormikForm } from "components/FormikForm/FormikForm";
import { CalendarIcon } from "components/icons/CalendarIcon";
import { YYYY_MM_DD } from "constants/date";
import dayjs from "dayjs";
import { Field, FieldProps, Form, Formik, FormikValues } from "formik";
import { addTicketETDSchema } from "formValidations/ticketSchema";
import { useToast } from "hooks/useToast";
import { useAddTicketETDMutation } from "store/apis/chatTicket";
import { BackendError } from "types/utils/error";

export const AddTicketEtd = ({
  isOpen,
  close,
  ticketId,
}: {
  isOpen: boolean;
  close: () => void;
  ticketId: string;
}) => {
  const { alertToast, successToast } = useToast();
  const [addTicketEtd, { isLoading: isAdding }] = useAddTicketETDMutation();

  const handleSubmit = async (values: FormikValues) => {
    try {
      await addTicketEtd({
        etd_date: dayjs(values.estimated_delivery_time).format(YYYY_MM_DD),
        ticketId,
      }).unwrap();
      successToast({ message: "ETD added successfully" });
      close();
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content>
        <FormikForm
          initialValues={{
            estimated_delivery_time: "",
          }}
          onSubmit={handleSubmit}
          validationSchema={addTicketETDSchema}
          validateOnChange
        >
          {({ setFieldValue }) => {
            return (
              <>
                <Modal.Header>
                  <Modal.Title>Set ETD for Ticket</Modal.Title>
                  <Modal.Close type="button" />
                </Modal.Header>
                <Modal.Body className="t-space-y-4">
                  <Field name="estimated_delivery_time">
                    {({ field }: FieldProps) => {
                      return (
                        <DateInput
                          {...field}
                          portalId="estimated_delivery_time_portal"
                          onDateChange={(date) =>
                            setFieldValue(
                              "estimated_delivery_time",
                              String(date)
                            )
                          }
                          minDate={dayjs().startOf("day").toDate()}
                          rightComponent={
                            <span className="t-text-text-30 -t-mt-0.5">
                              <CalendarIcon />
                            </span>
                          }
                          label="New ETD"
                          required
                        />
                      );
                    }}
                  </Field>
                </Modal.Body>
                <Modal.FooterButtonGroup>
                  <Modal.RawClose asChild>
                    <Button type="button">Cancel</Button>
                  </Modal.RawClose>
                  <Button
                    customType="primary"
                    type="submit"
                    disabled={isAdding}
                    isLoading={isAdding}
                  >
                    Save
                  </Button>
                </Modal.FooterButtonGroup>
              </>
            );
          }}
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
